import styled from "styled-components";

export const ToggleSlider = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  background: ${(props) => (props.isActive ? "#ffffff" : "#6C6C6C")};
  float: ${(props) => props.isActive && "right"};
`;

export const ToggleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${(props) => (props.isActive ? "flex-end" : "flex-start")};
  width: 5rem;
  height: 2.5rem;
  padding: 0.5rem;
  border-radius: 2.2rem;
  background: ${(props) => (props.isActive ? "#FF5D4C" : "#ffffff")};
  cursor: pointer;
  margin: 0 1rem 0 0;
  border: 1px solid ${(props) => (props.isActive ? "#FF5D4C" : "#6C6C6C")};

  &:hover {
    ${ToggleSlider} {
      background: ${(props) => !props.isActive && "#6C6C6C"};
    }
  }

  ${(props) => props.thisStyles};
`;

export const ToggleWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
`;
